import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from '@paypalcorp/pp-react';
import { saveAs } from 'file-saver';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from './CodeActions.module.less';
import { trackButtonClick } from '../../../lib/fpti';
import clientLogger from '../../../lib/logger';
import { getBaseZipFile } from '../getBaseZipFile';
import { useSelector } from 'react-redux';
import { PARTNER } from '../../../lib/constants';

const CodeActions = ({ content }) => {
  const {
    code: {
      language: { backend, frontend }
    },
    product
  } = useContext(IntegrationPageSectionContext);
  const { rows } = content;
  const appIntegrationType = useSelector((state) => state?.app?.appIntegrationType);

  const handleAction = async (text, url, action) => {
    if (action === 'download') {
      trackButtonClick(text, null, url);
      try {
        const zip = await getBaseZipFile({ appIntegrationType, product, frontend, backend });

        const contentZip = await zip.generateAsync({ type: 'blob' });
        const fileName = [appIntegrationType === PARTNER ? PARTNER : '', product, frontend, backend]
          .filter(Boolean)
          .join('_');
        saveAs(contentZip, fileName);
      } catch {
        clientLogger.error('CLIENT:ERROR', { error: 'Error fetching zip file' });
      }
    } else {
      trackButtonClick(text, url);
      window.open(url);
    }
  };

  return (
    <div className={styles.code_actions_container}>
      {rows.map(({ buttons }, index) => (
        <Row key={`row_${index}`}>
          {buttons.map(({ text, url, icon, action }, index) => (
            <Col key={`col_${index}`}>
              <Button
                onClick={() => {
                  handleAction(text, url, action);
                }}
                secondary
                size="lg"
                className={styles.code_action_button_container}
              >
                <div className={styles.code_action_button_content}>
                  <img className={styles.code_action_icon} src={icon} alt="" />
                  {text}
                </div>
              </Button>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

CodeActions.propTypes = { content: PropTypes.object };
CodeActions.defaultProps = { content: { rows: [] } };

export default CodeActions;
